import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/FontAwesome/solid/whistle.svg";

export function WhistleClassicSolidIcon(props: SxProps) {
    return (
        <SvgIcon
            component={Icon}
            inheritViewBox
            sx={{
                width: "24px",
                height: "24px",
                ...props,
            }}
        />
    );
}
